import { SelectOption } from "./types";

export const optionsReferralSource: SelectOption[] = [
  { value: "Google", label: "Google" },
  { value: "Facebook", label: "Facebook" },
  { value: "Instagram", label: "Instagram" },
  { value: "Indicação", label: "Indicação de amigo" },
  { value: "Outros", label: "Outros" },
];
